module.exports = __webpack_public_path__ + "static/img/11.5c59cd2c.svg";